/** User-facing copy for NEX HTTP statuses shown as invoice reason badges (feed + detail header). */
export function getNexHttpReasonBadgeCopy(status: number): { label: string; tooltip: string } {
    switch (status) {
        case 401:
            return {
                label: 'Auth',
                tooltip:
                    'Missing or invalid credentials or token. Correct sign-in, token usage, or required auth headers. (HTTP 401)',
            };
        case 403:
            return {
                label: 'Auth',
                tooltip:
                    'Authenticated but not permitted for this action. Verify access, permissions, customer setup, or token claims. (HTTP 403)',
            };
        case 400:
            return {
                label: 'NEX Error',
                tooltip:
                    'NEX returned an error for this request. Review details and try again, or contact Yaxle support if it persists. (HTTP 400)',
            };
        case 422:
            return {
                label: 'Invalid data',
                tooltip: 'Request shape or values are invalid. Correct the payload or form values and retry. (HTTP 422)',
            };
        case 404:
            return {
                label: 'Not found',
                tooltip:
                    'Requested resource or related object could not be found. Confirm identifiers, environment, and current data. (HTTP 404)',
            };
        case 500:
        case 503:
            return {
                label: 'Internal',
                tooltip: `Unexpected server or platform failure. Retry later; contact Yaxle if it continues. (HTTP ${status})`,
            };
        default:
            return {
                label: String(status),
                tooltip: `NEX submission error (HTTP ${status}).`,
            };
    }
}
